var _g;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 46,
    height: 46,
    rx: 23,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.4837 8.31658C25.8411 10.1166 25.0088 12.51 24.5583 14.7368C24.1077 16.9636 24.7673 18.3173 26.9693 17.8532C29.8257 17.3224 30.8268 16.7157 33.0527 16.5054C35.4116 16.2827 36.006 16.9998 36.1992 17.6243C36.4112 18.5031 35.9372 19.06 35.9856 19.5726C36.0336 20.0803 38.0225 20.1485 38.179 21.8058C38.3473 23.5875 36.7646 23.6115 36.8125 24.1191C36.861 24.6317 38.1949 24.7618 38.327 26.1604C38.4595 27.5638 36.6347 27.8667 36.6949 28.5038C36.755 29.1408 37.4218 29.2034 37.5059 30.0942C37.5905 30.9901 35.9391 33.0742 29.3893 33.6928C18.2424 34.615 19.3117 31.9431 14.0719 32.4379L13.1694 22.8823C15.9224 22.6223 15.5727 20.3405 17.2363 18.3858C18.8928 16.3012 20.9825 11.8609 21.3367 8.61379C21.6593 6.39906 23.7206 7.23376 24.4837 8.31658L24.4837 8.31658Z",
    fill: "#21BB71"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGood);
export default __webpack_public_path__ + "static/media/badge_good.5bff6350.svg";
export { ForwardRef as ReactComponent };